import Tag from 'shared-assets/components/Tag';

angular
  .module('kareo.ui.shared.directives.k-tag', [
    'react'
  ])
  .directive('kTag', kTag);

function kTag(reactDirective) {
    return reactDirective(Tag);
}

kTag.$inject = ['reactDirective'];
